import dayjs from '@/services/date'
// eslint-disable-next-line
import { ShortTermBooking } from '@/models/bookings/responses/shortTermBooking'
// eslint-disable-next-line
import { BookingOverviewCountsViewModel } from '@/models/bookings/responses/bookingOverviewCountsViewModel'
import { ModelApiService } from './BaseApiService'

export default class BookingsApiService extends ModelApiService {
  constructor() {
    super('bookings')
  }

  async getFeedbackFormUrl(bookingId) {
    return await this.get(`${bookingId}/feedback-form`)
  }

  async submitQuickFeedback(bookingId, data) {
    return await this.post(`${bookingId}/quick-feedback`, data)
  }

  async checkReplaceMeStatus(clientId) {
    return await this.get('replace-me-status', { clientId })
  }

  async submitReplaceMeBooking(payload) {
    return await this.post('replaceMe', payload)
  }

  async cancelBooking(bookingId, payload) {
    return await this.post(`${bookingId}/cancel`, payload)
  }

  async extendBooking(bookingId, payload) {
    return await this.post(`${bookingId}/extend`, payload)
  }

  /**
   * Returns booking overview statistics for a given year and by the selected client ids
   * @param {number[]} clientIds
   * @param {number|string} year
   * @returns {Promise<BookingOverviewCountsViewModel[]>}
   */
  async getBookingOverview(clientIds, year) {
    const newDate = new Date(year, 1, 1)

    const dateFromLocal = dayjs(newDate)
      .startOf('year')
      .format('YYYY-MM-DD')
    const dateToLocal = dayjs(newDate)
      .endOf('year')
      .format('YYYY-MM-DD')

    const urlArgs = new URLSearchParams(
      clientIds.map((clientId) => ['clientIds', clientId])
    )

    urlArgs.append('dateFromLocal', dateFromLocal)
    urlArgs.append('dateToLocal', dateToLocal)

    return this.get(`overview?${urlArgs}`)
  }

  /**
   * Returns booking summaries for a given date and by the selected client ids
   * @param {number[]} clientIds
   * @param {string} dateFromStringLocal
   * @returns {Promise<ShortTermBooking[]>}
   */
  async getSummaryBookingsByDate(clientIds, dateFromLocal) {
    const urlArgs = new URLSearchParams(
      clientIds.map((clientId) => ['clientIds', clientId])
    )
    urlArgs.append('dateFromLocal', dateFromLocal)

    return this.get(`summary?${urlArgs}`)
  }

  /**
   * Checks candidate's availability for all the dates which the booking extends up to and returns the schedule for the booking location.
   * @param {number} bookingId
   * @param {string} endDateLocal
   */
  async getExtendBookingCandidatesAndSchedule(bookingId, endDateLocal) {
    return await this.get(
      `${bookingId}/extend/scheduling?endDateLocal=${endDateLocal}`
    )
  }
}
